<h1 mat-dialog-title>{{data.heading}}</h1>
<div mat-dialog-content>
  <p>{{ data.dialogContext }} ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color={{color}} [mat-dialog-close]="{ confirm: true }">Confirm</button>
</mat-dialog-actions>
